import React from 'react';
// Analytics
import { usePageTracking } from '../../hooks/useAnalytics';
// Constants
import { CompanyName, CurrentLocation } from '../../utils/Constants';
// Components
import HomePageMainContainer from '../../components/home/HomePageMainContainer';
import HomePageHeader from '../../components/home/HomePageHeader';
import { HelmetItem } from '../../components/utils/HelmetItem';
// Meta
import {
  homePageAdditionalMeta,
  homePageStructuredData,
} from '../../utils/data/MetaData';

const HomePage = React.memo(() => {
  usePageTracking();

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Home'
        desc={`Welcome to ${CompanyName} — Supreme Goddess of Erotic and Stern Discipline. Explore bespoke BDSM services, gallery, reviews, and opportunities tailored to your desires.`}
        keywords={`home, ${CompanyName}, dominatrix, BDSM, professional domme, services, gallery, reviews`}
        additionalMeta={homePageAdditionalMeta}
        structuredData={homePageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour2 text-colour1 dark:bg-colour2 dark:text-colour1 font-poppins no__highlights'>
        <div className='fixed grid grid-rows-[auto_auto_1fr] lg:grid-rows-reg max-h-screen min-h-screen'>
          {/* Currently Booking location */}
          <section className='hidden md:grid w-full text-center lg:text-left px-4 h-fit py-1 border-b-2 border-solid border-colour7 dark:border-colour7'>
            Currently Booking: {CurrentLocation}
          </section>

          {/* Header */}
          <HomePageHeader />
        </div>

        {/* Main page content */}
        <HomePageMainContainer />
      </div>
    </>
  );
});

export default HomePage;
